import type { OnInit } from '@angular/core';
import { Component, Input } from '@angular/core';
import { getRouteLoadingData } from '@core/jss-routing';
import { InnogyComponentRendering } from '@core/jss-models';
import { getItemLinkFieldValue } from '@core/jss-utils';
import { select, Store } from '@ngrx/store';
import {
  ExperienceEditorComponent,
  ExperienceEditorLiveDirective,
  ExperienceEditorPreviewDirective,
} from '@core/experience-editor-components';
import { NgClass, AsyncPipe } from '@angular/common';
import { JssModule } from '@sitecore-jss/sitecore-jss-angular';
import { SkeletonLoadingCardComponent } from '@legacy/common-ui-shared';

@Component({
  selector: 'wl-colset-mijn-39',
  templateUrl: './colset-mijn-39.component.html',
  styleUrls: ['./colset-mijn-39.component.scss'],
  host: { ngSkipHydration: 'true' },
  standalone: true,
  imports: [
    ExperienceEditorComponent,
    ExperienceEditorLiveDirective,
    NgClass,
    JssModule,
    SkeletonLoadingCardComponent,
    ExperienceEditorPreviewDirective,
    AsyncPipe,
  ],
})
export class ColsetMijn39Component implements OnInit {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() rowSpacing?: string;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() contentOptionsLeft?: string;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() contentOptionsCenter?: string;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() contentOptionsRight?: string;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() rendering?: InnogyComponentRendering;

  route$ = this.store$.pipe(select(getRouteLoadingData));

  constructor(private readonly store$: Store<any>) {}

  ngOnInit() {
    this.renderingToModel(this.rendering);
  }

  private renderingToModel(rendering: InnogyComponentRendering | undefined) {
    if (rendering == null || rendering.fields == null) {
      return;
    }

    this.rowSpacing = getItemLinkFieldValue(rendering.fields, 'rowSpacing', '');

    // first set theming options if selected
    this.contentOptionsLeft = getItemLinkFieldValue(
      rendering.fields,
      'backgroundThemeLeft',
      ''
    );

    this.contentOptionsLeft +=
      ' ' + getItemLinkFieldValue(rendering.fields, 'textThemeLeft', '');

    // first set theming option if selected
    this.contentOptionsRight = getItemLinkFieldValue(
      rendering.fields,
      'backgroundThemeRight'
    );

    this.contentOptionsRight +=
      ' ' + getItemLinkFieldValue(rendering.fields, 'textThemeRight', '');

    // first set theming option if selected
    this.contentOptionsCenter = getItemLinkFieldValue(
      rendering.fields,
      'backgroundThemeCenter',
      ''
    );

    this.contentOptionsRight +=
      ' ' + getItemLinkFieldValue(rendering.fields, 'textThemeCenter', '');
  }
}
